import React from 'react';
import { Form } from 'react-bootstrap';

import { PLATES_AVAILABLE, PLATE_LAYERS, defaultOn, usePlatesState } from './platesConfig';

const NOTE = { padding: '0 8px 8px', fontSize: 11, color: '#6b6b6b' };

/**
 * Sidebar cards for the plate overlays: a checkbox each. Showing, hiding and
 * fading individual plates is done in the plate list on the left of the map
 * (PlatesPanel), which opens while either layer is on. Renders nothing without
 * a plates endpoint, so a production build never offers them. `styles` is the
 * sidebar's own style object.
 */
export function PlatesSidebarCards({ overlayVisibility, setOverlayVisisbility, styles }) {
  const plates = usePlatesState();
  if (!PLATES_AVAILABLE) return null;

  return PLATE_LAYERS.map((p) => {
    const on = !!overlayVisibility[p.key];
    const index = plates.index[p.key];
    return (
      <div key={p.key} style={styles.overlayCard}>
        <div style={styles.overlayHeader}>
          <div style={styles.overlayCheckbox} title={p.title}>
            <Form.Check
              id={`${p.id}-overlay`}
              label={p.label}
              checked={on}
              onChange={() => setOverlayVisisbility({ ...overlayVisibility, [p.key]: !on })}
            />
          </div>
        </div>
        {on && index?.status === 'denied' && (
          <div style={NOTE}>
            GeoServer refused this layer to an anonymous caller (it is
            role-restricted there). Nothing will draw.
          </div>
        )}
        {on && index?.status === 'error' && (
          <div style={NOTE}>Could not load the plate index from GeoServer.</div>
        )}
        {on && index?.status === 'ok' && (
          <div style={NOTE}>
            {index.features.length} plate{index.features.length === 1 ? '' : 's'},
            {' '}{index.features.filter((f) => defaultOn(f.properties)).length} shown by default.
            {' '}Show, hide and fade them in the plate list on the map.
          </div>
        )}
      </div>
    );
  });
}
